import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import moment from 'moment';
import VueClipboard from 'vue-clipboard2';
import router from './router/router';
import swal from 'sweetalert2';
import store from './store/store';
import { sync } from 'vuex-router-sync';
const unsync = sync(store, router); // done. Returns an unsync callback fn

Vue.prototype.$moment = moment;
Vue.prototype.$http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});
Vue.prototype.$http.interceptors.request.use(
  (config) => {
		if(store.state.access_token) config.headers['Authorization'] = 'Basic ' + btoa(store.state.access_token + ':*');
    return config;
  }, 

  (error) => {
    return Promise.reject(error);
  }
);
Vue.prototype.$http.interceptors.response.use(
  (response) => {
    let tvs = response.headers['trvlporter-version'].toString();
    let cvs = process.env.VUE_APP_VERSION.toString();
    let tvs_split = tvs.split('.');
    let cvs_split = cvs.split('.');  
    tvs = parseInt(tvs_split[0]) + '.' + parseInt(tvs_split[1]);
    cvs = parseInt(cvs_split[0]) + '.' + parseInt(cvs_split[1]);
    if(cvs < tvs) {
      Vue.prototype.$swal.fire({
        title: 'You Need to Refresh',
        html: 'The page you are accessing is outdated<br><br>Version Detected: ' + process.env.VUE_APP_VERSION + '<br>',
        confirmButtonText: 'Refresh Page',
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(result => {
        if(result.value) {
          location.reload(true);
        }
      });
    }
    return response;
  }, (error) => {
    return Promise.reject(error);
  }
);

Vue.prototype.$swal = swal.mixin({
  showConfirmButton: true,
  showCancelButton: true,
  reverseButtons: true,
  animation: false,
  confirmButtonColor: '#000',
  scrollbarPadding: false
});
Vue.prototype.$toast = swal.mixin({
  toast: true,
  position: 'center',
  showConfirmButton: false,
  timer: 3000,
  type: 'success'
});


Vue.config.productionTip = false
Vue.use(VueClipboard);


//Redirect for non authed
router.beforeEach((to, from, next) => {
  const noAuthRequired = to.matched.some((route) => route.meta.noauth);
  const authed = store.getters.isAuthorized;
  if (!noAuthRequired && !authed) {
    let redir = {
      path: '/auth'
    }
    if(to.fullPath != '/') redir.query = { redirect: to.fullPath };
    next(redir);
  } else if(noAuthRequired && authed) { 
    next({path: '/account/trips'});
  } else {
    next();
  }
});


//Filters
Vue.filter('currency', function (value) {
  if(isNaN(parseInt(value)) || parseInt(value) === 0) return '-';
  let prefix = (value < 0 ? '-' : '');
  let suffix = (value < 0 ? '' : '');
  
  return prefix + Math.abs(parseFloat(value / 100)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + suffix;
});


import './plugins/vuetify';


window.TP_PORTAL = new Vue({
  router,
  store,
  components: { App },
  render: h => h(App),
  beforeCreate: function() {
    store.commit('resetCaches');
    store.dispatch('checkForUpdates');
  },
  created: function() {
    
  },
  mounted: function() {
    var ref = this;
    //Triggers docFocused when user re-focuses browser window
    window.addEventListener('focus', function() { ref.docFocused(); });
    
    drift.on('ready', function(api) {
      ref.drift_api = api;
      if(!store.getters.isAuthorized) api.widget.hide();
    });
  },
  data: function() {
    return {
      //Common rules list for form validation
      rules: {
        required: function(value) { return !!value || 'Required.'; }
      },
      drift_api: null
    }
  },
  computed: {
    cdn: function() {
      return process.env.VUE_APP_CDN_URL;
    }
  },
  methods: {
    docFocused: function() {
      store.dispatch('checkForUpdates');
    }
  }
}).$mount('#app');
